import { useMemo } from "react";
import { useHistory } from "react-router-dom";

export const useNavigator = () => {
  const history = useHistory();
  const navigateTo = useMemo(() => {
    return (path: string, historyState?: string[]) => {
      const statePageVisitedArray = history.location.state
        ? history.location.state["pageVisited"]
        : [];
      const pageVisitedArray = [
        ...statePageVisitedArray,
        history.location.pathname,
      ];

      history.push({
        pathname: path,
        state: {
          pageVisited: historyState || pageVisitedArray,
        },
      });
      //   dispatch(push(path));
    };
  }, [history]);

  const goBack = () => {
    const statePageVisitedArray = history.location.state
      ? history.location.state["pageVisited"]
      : [];
    const clonedVisitedPages = [...statePageVisitedArray];
    const goBackPage = clonedVisitedPages.pop(); // TODO: check this
    if (goBackPage) {
      const pageVisitedArray = clonedVisitedPages;
      history.push({
        pathname: goBackPage,
        state: {
          pageVisited: pageVisitedArray,
        },
      });
    } else {
      history.push({
        pathname: "/",
        state: {
          pageVisited: [],
        },
      });
    }
  };

  const replaceHistory = (path: string, historyState?: string[]) => {
    history.replace(path, {
      pageVisited: historyState,
    });
  };

  return { navigateTo, goBack, replaceHistory };
};
